import React from 'react';
import PropTypes from 'prop-types';
import { Card, Typography } from 'antd';
import { formatReadingKm } from './format';

const { Title, Text } = Typography;

/**
 * The raw readings behind the odometer distance, kept as their own card because they are
 * the audit trail: a disputed distance is settled by these two numbers and the photos
 * attached to them, not by the derived km.
 */
function OdometerReadingsCard({ model }) {
	const { distances } = model;

	const rows = [
		{
			key: 'start',
			label: 'Start KM',
			value: formatReadingKm(distances.odometerStart),
			note: distances.odometerStart === null ? 'Not captured at check-in' : null,
		},
		{
			key: 'end',
			label: 'End KM',
			value: formatReadingKm(distances.odometerEnd),
			note: distances.odometerEnd === null ? 'Not captured at closure' : null,
		},
	];

	return (
		<Card
			bodyStyle={{ padding: '24px 28px' }}
			style={{
				borderRadius: 14,
				border: 'none',
				boxShadow: '0 4px 12px rgba(0,0,0,0.04)',
				marginTop: 20,
			}}
		>
			<Title level={5} style={{ margin: 0, fontWeight: 700, fontSize: 17 }}>
				Odometer Readings
			</Title>

			<div style={{ marginTop: 12 }}>
				{rows.map((row, index) => (
					<div
						key={row.key}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'baseline',
							gap: 16,
							padding: '16px 0',
							borderBottom: index === rows.length - 1 ? 'none' : '1px solid #f1f5f9',
						}}
					>
						<div>
							<Text style={{ fontSize: 14, color: '#334155' }}>{row.label}</Text>
							{row.note && (
								<Text
									style={{
										display: 'block',
										fontSize: 12,
										color: row.tone === 'error' ? '#dc2626' : '#94a3b8',
									}}
								>
									{row.note}
								</Text>
							)}
						</div>
						<Text
							strong
							style={{
								fontSize: 15,
								whiteSpace: 'nowrap',
								color: row.tone === 'error' ? '#dc2626' : '#0f172a',
							}}
						>
							{row.value}
						</Text>
					</div>
				))}
			</div>
		</Card>
	);
}

OdometerReadingsCard.propTypes = {
	model: PropTypes.object.isRequired,
};

export default OdometerReadingsCard;
